/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tm_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Wallace rule (2 °C per A/T, 4 °C per G/C) is a reasonable quick estimate for oligos shorter than about 14 bases, but it ignores salt, concentration and sequence context, so it drifts for longer primers.`)
};

const es_tm_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La regla de Wallace (2 °C por A/T, 4 °C por G/C) es una estimación rápida razonable para oligos de menos de unas 14 bases, pero ignora la sal, la concentración y el contexto de secuencia, así que se desvía en cebadores más largos.`)
};

const de_tm_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Wallace-Regel (2 °C pro A/T, 4 °C pro G/C) ist eine vernünftige schnelle Schätzung für Oligos kürzer als etwa 14 Basen, ignoriert aber Salz, Konzentration und Sequenzkontext, sodass sie bei längeren Primern abweicht.`)
};

const nl_tm_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De Wallace-regel (2 °C per A/T, 4 °C per G/C) is een redelijke snelle schatting voor oligo's korter dan ongeveer 14 basen, maar negeert zout, concentratie en sequentiecontext, dus wijkt af voor langere primers.`)
};

const fr_tm_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La règle de Wallace (2 °C par A/T, 4 °C par G/C) est une estimation rapide raisonnable pour les oligos de moins d'environ 14 bases, mais elle ignore le sel, la concentration et le contexte de séquence, donc elle dérive pour les amorces plus longues.`)
};

const it_tm_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La regola di Wallace (2 °C per A/T, 4 °C per G/C) è una stima rapida ragionevole per oligo più corti di circa 14 basi, ma ignora sale, concentrazione e contesto di sequenza, quindi si allontana dal valore reale per primer più lunghi.`)
};

const pt_br2_tm_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A regra de Wallace (2 °C por A/T, 4 °C por G/C) é uma estimativa rápida razoável para oligos com menos de cerca de 14 bases, mas ignora sal, concentração e contexto de sequência, então se desvia para primers mais longos.`)
};

const pt_tm_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A regra de Wallace (2 °C por A/T, 4 °C por G/C) é uma estimativa rápida razoável para oligonucleótidos com menos de cerca de 14 bases, mas ignora o sal, a concentração e o contexto da sequência, pelo que se afasta em primers mais longos.`)
};

const ja_tm_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wallace法（A/Tあたり2℃、G/Cあたり4℃）は、約14塩基未満のオリゴには妥当な簡易推定になりますが、塩濃度、濃度、配列の文脈を無視しているため、長いプライマーでは誤差が大きくなります。`)
};

const zh_tm_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对于长度小于约 14 个碱基的寡核苷酸，Wallace 规则（每个 A/T 2 °C，每个 G/C 4 °C）是一个合理的快速估算方法，但它忽略了盐浓度、浓度和序列背景，因此对较长引物的偏差会增大。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tm_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tm_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tm_faq_a3", locale)
	if (locale === "en") return en_tm_faq_a3(inputs)
	if (locale === "es") return es_tm_faq_a3(inputs)
	if (locale === "de") return de_tm_faq_a3(inputs)
	if (locale === "nl") return nl_tm_faq_a3(inputs)
	if (locale === "fr") return fr_tm_faq_a3(inputs)
	if (locale === "it") return it_tm_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_tm_faq_a3(inputs)
	if (locale === "pt") return pt_tm_faq_a3(inputs)
	if (locale === "ja") return ja_tm_faq_a3(inputs)
	return zh_tm_faq_a3(inputs)
};